const stateToggler = (currentState, setState) => {
    currentState ? setState(false) : setState(true);
};

export default stateToggler;